// @flow
import ResponseSaver from 'api/responseSaver'
import type { ResponseWithAnswersToHiddenQuestions } from 'types/response'

type Cell = {
  question_column: number,
  question_row: number,
}

async function saveResponse({
  extraResponses = [],
  mode,
  response,
  submit = false,
  updatedCellQuestions,
  updatedQuestions,
  lockInternalForm = false,
  save_answer_repeat_section = [],
}: {
  extraResponses: Array<string>,
  mode: string,
  response: ResponseWithAnswersToHiddenQuestions,
  submit: ?boolean,
  updatedCellQuestions: Array<Cell>,
  updatedQuestions: Array<number>,
  lockInternalForm: boolean,
  save_answer_repeat_section: Array<any>,
}): Promise<boolean> {
  const data = {
    create_matrix_row: [],
    delete_answer: [],
    delete_answer_file: [],
    delete_answer_matrix: [],
    extraResponses,
    mode,
    response,
    save_answer_batch: [],
    save_answer_matrix: [],
    save_answer_repeat_section,
    submit: submit,
    updatedCellQuestions,
    updatedQuestions,
    lock_internal_form: lockInternalForm,
  }

  const responseSaver = new ResponseSaver(data)
  return await responseSaver.execute()
}

export default saveResponse
